import type {
  DefaultEntityFilters,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

export class EntityMembershipFilter implements EntityFilter {
  constructor(readonly userRef: string) {}

  getCatalogFilters(): Record<string, string | string[]> {
    return { 'relations.hasMember': this.userRef };
  }

  toQueryValue(): string {
    return this.userRef;
  }
}

export type TeamsEntityFilters = DefaultEntityFilters & {
  membership?: EntityMembershipFilter;
};
